@for (preset of presets; track preset) {
  <button
    (click)="valueChange.emit(preset.date)"
    class="preset"
    [class.active]="preset.date === value"
    #presetContent
    [attr.title]="presetContent.textContent">
    {{ preset.label }} <span class="preset-tooltip">({{ preset.tooltip }})</span>
  </button>
}
